export default __webpack_public_path__ + "static/media/edit.54f15b82.svg";